import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
    FiLock, FiUserCheck, FiArrowLeft, FiArrowRight,
} from 'react-icons/fi';
import './styles.css';

// Tela seletora ANTES de escolher o fluxo. Antes o link do login ia direto pro
// "Esqueci minha senha", e a opção de "Recuperar conta" (aluno antigo só com
// CPF) ficava escondida — confundia. Aqui o usuário escolhe claramente:
//   - Recuperar SENHA  -> /esqueci-senha     (tem email+senha, esqueceu a senha)
//   - Recuperar CONTA  -> /recuperar-conta    (aluno antigo, só CPF, sem email)
// A lógica de cada fluxo continua a mesma — só mudou a experiência de entrada.
export default function RecuperarAcesso() {
    const navigate = useNavigate();

    return (
        <div style={styles.page}>
            <div style={styles.card}>
                <div style={styles.brand}>
                    <div style={styles.brandLogo}>U</div>
                    <div style={styles.brandText}>
                        <span style={styles.brandName}>UEN</span>
                        <span style={styles.brandTag}>Estudantil</span>
                    </div>
                </div>

                <h1 style={styles.title}>Recuperar acesso</h1>
                <p style={styles.subtitle}>
                    O que você precisa? Escolha uma das opções abaixo.
                </p>

                <div style={styles.opcoes}>
                    {/* Recuperar SENHA */}
                    <button
                        type="button"
                        onClick={() => navigate('/esqueci-senha')}
                        style={styles.opcao}
                        className="ra-opcao"
                    >
                        <div style={{ ...styles.opcaoIcone, background: '#ECFDF5', color: '#059669' }}>
                            <FiLock size={22} />
                        </div>
                        <div style={styles.opcaoTexto}>
                            <div style={styles.opcaoTitulo}>Recuperar senha</div>
                            <div style={styles.opcaoDesc}>
                                Você já acessa com <strong>email e senha</strong> e só esqueceu a senha.
                                Enviamos um link pro seu email.
                            </div>
                        </div>
                        <FiArrowRight size={18} style={styles.opcaoSeta} />
                    </button>

                    {/* Recuperar CONTA */}
                    <button
                        type="button"
                        onClick={() => navigate('/recuperar-conta')}
                        style={styles.opcao}
                        className="ra-opcao"
                    >
                        <div style={{ ...styles.opcaoIcone, background: '#F0F9FF', color: '#0EA5E9' }}>
                            <FiUserCheck size={22} />
                        </div>
                        <div style={styles.opcaoTexto}>
                            <div style={styles.opcaoBadge}>Já é antigo na UEN? Recupere sua conta</div>
                            <div style={styles.opcaoTitulo}>Recuperar conta</div>
                            <div style={styles.opcaoDesc}>
                                Você se cadastrou antigamente <strong>só com CPF</strong> e não tem email/senha.
                                Recupere o acesso com <strong>CPF + data de nascimento</strong>.
                            </div>
                        </div>
                        <FiArrowRight size={18} style={styles.opcaoSeta} />
                    </button>
                </div>

                <Link to="/login" style={styles.backLink}>
                    <FiArrowLeft size={14} /> Voltar para o login
                </Link>
            </div>
        </div>
    );
}

const styles = {
    page: {
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #ECFDF5 0%, #FFFFFF 60%, #F0FDFA 100%)',
        display: 'grid',
        placeItems: 'center',
        padding: '24px 16px',
        fontFamily: "'Inter', 'Roboto', system-ui, sans-serif",
        color: '#0F172A',
    },
    card: {
        width: '100%',
        maxWidth: 480,
        background: '#FFFFFF',
        borderRadius: 16,
        boxShadow: '0 24px 48px -16px rgba(15, 23, 42, 0.18), 0 0 0 1px rgba(15,23,42,0.04)',
        padding: '40px 36px',
    },
    brand: { display: 'flex', alignItems: 'center', gap: 12, marginBottom: 28 },
    brandLogo: {
        width: 44, height: 44, borderRadius: 12,
        background: 'linear-gradient(135deg, #059669 0%, #0D9488 100%)',
        color: '#fff', display: 'grid', placeItems: 'center',
        fontWeight: 800, fontSize: 18,
        boxShadow: '0 4px 12px -2px rgba(5, 150, 105, 0.4)',
    },
    brandText: { display: 'flex', flexDirection: 'column', lineHeight: 1.1 },
    brandName: { fontWeight: 700, fontSize: '1.1rem', color: '#0F172A' },
    brandTag: { fontSize: '0.75rem', color: '#64748B', marginTop: 2 },

    title: {
        fontSize: '1.6rem', fontWeight: 700, color: '#0F172A',
        margin: '0 0 8px', letterSpacing: '-0.02em',
    },
    subtitle: { color: '#64748B', margin: '0 0 24px', fontSize: '0.92rem', lineHeight: 1.55 },

    opcoes: { display: 'flex', flexDirection: 'column', gap: 12 },
    opcao: {
        display: 'flex', alignItems: 'center', gap: 14,
        textAlign: 'left', width: '100%',
        background: '#FFFFFF', border: '1.5px solid #E2E8F0', borderRadius: 14,
        padding: '16px 16px', cursor: 'pointer', fontFamily: 'inherit',
        transition: 'border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease',
    },
    opcaoIcone: {
        width: 44, height: 44, borderRadius: 12, flexShrink: 0,
        display: 'grid', placeItems: 'center',
    },
    opcaoTexto: { flex: 1, minWidth: 0 },
    opcaoBadge: {
        display: 'inline-block', marginBottom: 6,
        background: '#0EA5E9', color: '#FFFFFF',
        fontSize: '0.62rem', fontWeight: 800, letterSpacing: '0.06em',
        textTransform: 'uppercase', padding: '3px 8px', borderRadius: 999,
    },
    opcaoTitulo: { fontSize: '1.02rem', fontWeight: 700, color: '#0F172A' },
    opcaoDesc: { fontSize: '0.82rem', color: '#64748B', lineHeight: 1.5, marginTop: 3 },
    opcaoSeta: { color: '#94A3B8', flexShrink: 0 },

    backLink: {
        display: 'inline-flex', alignItems: 'center', gap: 6,
        marginTop: 24, color: '#059669', fontSize: '0.88rem',
        fontWeight: 600, textDecoration: 'none',
    },
};
